import { getToken } from '../../utils/auth';
import { getAuthTokenAsync } from '../../utils/authToken';
import { checkStatus, handleError } from '../../utils/api';
import apiFetch from '../core/apiFetch';

interface StateByZip {
  stateId: number | null;
}

// Resolves a zip to its state_id via the guest signup valid_zips endpoint. Used by the
// coverage-check flow, which collects a zip (not a state) and has no authenticated patient,
// so it falls back to the app token when there's no user token.
const getStateByZipAsync = async (zip: string): Promise<StateByZip> => {
  const token = getToken() || (await getAuthTokenAsync());
  const url = `api/v1/signup/valid_zips/search?zip=${zip}`;

  try {
    const response = await apiFetch(token, url, { method: 'GET' });
    await checkStatus(response);
    const { state_id: stateId } = await response.json();

    return { stateId: stateId ?? null };
  } catch (error) {
    handleError('unexpected status - get state by zip', error);
    return { stateId: null };
  }
};

export default getStateByZipAsync;
